<template>
  <div class="modal fade" id="informModal" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <span class="text-left" style="font-size:14px">{{$t(messageConfirm)}}</span>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button type="button" class="btn btn-success" @click="ok()">{{$t("btn.mypage")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";

export default {
    name: "InformModal",
    data() {
        return {
            messageConfirm: null
        }
    },
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_INFORM_MODAL, (params) => {
            $('#informModal').modal({backdrop: 'static', keyboard: false});
            this.show(params);
        });
    },
    methods: {
        ok() {
            $("#informModal").modal("hide");
            this.$modal.closeInformModal();
        },
        show(params) {
            this.messageConfirm = params;
            $("#informModal").modal("show");
        }
    }
}
</script>

<style scoped>

</style>
